/* Winewinner.ch - Theme-Skripte (ohne Fremdbibliotheken) */
(function () {
  'use strict';

  /* ---------------------------------------------------- Bildslider Start */
  function initBannerSlider(root) {
    var track = root.querySelector('.slider--track');
    var slides = root.querySelectorAll('.slider--slide');
    if (!track || slides.length < 2) return;

    var dots = root.querySelectorAll('.slider--dots button');
    var index = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var auto = root.getAttribute('data-autoplay') === 'true';

    function show(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is--active', d === index);
      }
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function start() { if (auto) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var btnNext = root.querySelector('.slider--arrow.is--next');
    var btnPrev = root.querySelector('.slider--arrow.is--prev');
    if (btnNext) btnNext.addEventListener('click', function () { next(); start(); });
    if (btnPrev) btnPrev.addEventListener('click', function () { prev(); start(); });
    for (var k = 0; k < dots.length; k++) {
      (function (n) {
        dots[n].addEventListener('click', function () { show(n); start(); });
      })(k);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    /* Wischgesten */
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      x0 = null; start();
    }, { passive: true });

    show(0);
    start();
  }

  /* --------------------------------------------------- Produkt-Slider    */
  function initProductSlider(root) {
    var viewport = root.querySelector('.product-slider--viewport');
    var container = root.querySelector('.product-slider--container');
    var prev = root.querySelector('.product-slider--arrow.is--prev');
    var next = root.querySelector('.product-slider--arrow.is--next');
    if (!viewport || !container) return;
    var offset = 0;

    function maxOffset() {
      return Math.max(0, container.scrollWidth - viewport.clientWidth);
    }
    function step() {
      var item = container.querySelector('.product-slider--item');
      return item ? item.getBoundingClientRect().width : 240;
    }
    function apply() {
      var max = maxOffset();
      if (offset > max) offset = max;
      if (offset < 0) offset = 0;
      container.style.transform = 'translateX(' + (-offset) + 'px)';
      if (prev) prev.disabled = offset <= 0;
      if (next) next.disabled = offset >= max - 1;
    }
    if (next) next.addEventListener('click', function () { offset += step(); apply(); });
    if (prev) prev.addEventListener('click', function () { offset -= step(); apply(); });
    window.addEventListener('resize', function () { offset = 0; apply(); });
    apply();
  }

  /* ------------------------------------------------------------ Reiter   */
  function initTabs(root) {
    var links = root.querySelectorAll('.tab--link');
    var panes = root.querySelectorAll('.tab--container');
    for (var i = 0; i < links.length; i++) {
      (function (n) {
        links[n].addEventListener('click', function (e) {
          e.preventDefault();
          for (var j = 0; j < links.length; j++) {
            links[j].classList.toggle('is--active', j === n);
            if (panes[j]) panes[j].classList.toggle('is--active', j === n);
          }
        });
      })(i);
    }
  }

  /* -------------------------------------------------------- Mobiles Menue */
  function initMobileNav() {
    var toggle = document.querySelector('.mobile--toggle');
    var nav = document.querySelector('.mobile--nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () { nav.classList.toggle('is--open'); });
  }

  /* ------------------------------------------------------------ Filter     */
  function initFilter() {
    var knopf = document.querySelector('.filter--trigger');
    var panel = document.querySelector('.action--filter-options');
    if (!knopf || !panel) return;

    /* Sind Filter gesetzt, ist der Bereich von Anfang an offen. */
    if (panel.querySelector('.filter--active')) {
      panel.classList.add('is--open');
      knopf.setAttribute('aria-expanded', 'true');
    }

    knopf.addEventListener('click', function () {
      var offen = panel.classList.toggle('is--open');
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------------------ Merkzettel */
  var NOTE_KEY = 'ww-merkzettel';

  function noteRead() {
    try { return JSON.parse(localStorage.getItem(NOTE_KEY) || '[]'); } catch (e) { return []; }
  }
  function noteWrite(list) {
    try { localStorage.setItem(NOTE_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function noteCount() {
    var n = noteRead().length;
    var el = document.querySelector('[data-note-count]');
    if (el) el.textContent = n;
    var eintrag = document.querySelector('[data-note-entry]');
    if (eintrag) eintrag.style.display = n > 0 ? '' : 'none';
  }
  function initNoteButtons() {
    var list = noteRead();
    var btns = document.querySelectorAll('[data-note-handle]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        var handle = b.getAttribute('data-note-handle');
        var gemerkt = list.indexOf(handle) !== -1;
        b.classList.toggle('is--noted', gemerkt);
        var txt = b.querySelector('.action--text');
        if (txt) txt.textContent = gemerkt ? 'Gemerkt' : 'Merken';

        b.addEventListener('click', function () {
          var l = noteRead();
          var k = l.indexOf(handle);
          if (k === -1) { l.push(handle); } else { l.splice(k, 1); }
          noteWrite(l);
          var jetzt = l.indexOf(handle) !== -1;
          b.classList.toggle('is--noted', jetzt);
          if (txt) txt.textContent = jetzt ? 'Gemerkt' : 'Merken';
          noteCount();
        });
      })(btns[i]);
    }
    noteCount();
  }

  /* Merkzettel-Seite: zeigt nur die gemerkten Artikel */
  function initNotePage() {
    var seite = document.querySelector('[data-note-page]');
    if (!seite) return;
    var list = noteRead();
    var boxen = seite.querySelectorAll('[data-note-item]');
    var sichtbar = 0;
    for (var i = 0; i < boxen.length; i++) {
      var treffer = list.indexOf(boxen[i].getAttribute('data-note-item')) !== -1;
      boxen[i].style.display = treffer ? '' : 'none';
      if (treffer) sichtbar++;
    }
    var leer = seite.querySelector('[data-note-empty]');
    if (leer) leer.style.display = sichtbar ? 'none' : '';
  }

  /* ------------------------------------------------------------ Warenkorb */
  /*
    Die Mengenfelder schicken das Formular selbst ab, sobald sich eine Zahl
    aendert - so wie es der alte Shop tat. Der Knopf "Warenkorb aktualisieren"
    bleibt daneben stehen und funktioniert weiterhin; ohne JavaScript ist er
    der einzige Weg, deshalb wird er nicht versteckt.
  */
  function initCartForm() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    var knopf = form.querySelector('[data-cart-update]');
    var felder = form.querySelectorAll('input[name="updates[]"]');

    function absenden() {
      if (form.dataset.wirdGesendet === '1') return;
      form.dataset.wirdGesendet = '1';
      if (knopf) {
        knopf.disabled = true;
        knopf.textContent = 'Wird aktualisiert …';
      }
      /* requestSubmit haengt den Namen des Knopfes an - Shopify braucht "update". */
      if (form.requestSubmit && knopf) form.requestSubmit(knopf);
      else form.submit();
    }

    for (var i = 0; i < felder.length; i++) {
      (function (feld) {
        var vorher = feld.value;
        feld.addEventListener('change', function () {
          if (feld.value === vorher) return;
          if (feld.value === '' || isNaN(parseInt(feld.value, 10))) {
            feld.value = vorher;
            return;
          }
          absenden();
        });
        /* Enter im Mengenfeld soll aktualisieren, nicht zur Kasse springen. */
        feld.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); absenden(); }
        });
      })(felder[i]);
    }
  }

  /* --------------------------------------------------------- Altershinweis */
  /*
    Fragt beim ersten Besuch nach dem Geburtsdatum - Pflichtfeld, kein blosses
    "Ja". Gerechnet wird nur im Browser; gespeichert wird allein, dass die
    Pruefung bestanden wurde (localStorage). Das Datum selbst bleibt nirgends
    liegen.

    Bewusst gewaehlt:
    * Ohne localStorage (privater Modus, alte Browser) wird gar nicht gefragt.
      Sonst kaeme die Frage bei jedem Klick neu und der Shop waere unbenutzbar.
    * Zu jung speichert nichts - beim naechsten Besuch wird wieder gefragt.
    * Der Kasten laesst sich nicht mit Escape wegklicken; das waere kein
      Nachweis, sondern eine Zierde.
  */
  function initAgeGate() {
    var gate = document.querySelector('[data-age-gate]');
    if (!gate) return;

    var KEY = 'ww-age-ok';
    var speicher = null;
    try {
      speicher = window.localStorage;
    } catch (e) {
      return;                      /* kein Speicher -> nicht fragen */
    }

    /*
      Zum Vorfuehren und Pruefen: mit ?alter=neu in der Adresse wird die
      gemerkte Antwort verworfen und der Kasten kommt wieder. Sonst laesst er
      sich nach dem ersten Mal nur ueber die Browserdaten zurueckholen.
    */
    var neuFragen = /(^|[?&])alter=neu(&|$)/.test(window.location.search);
    try {
      if (neuFragen) speicher.removeItem(KEY);
      else if (speicher.getItem(KEY) === '1') return;
    } catch (e) {
      return;
    }

    var mindestalter = parseInt(gate.getAttribute('data-age-min'), 10) || 18;
    var frage = gate.querySelector('[data-age-frage]');
    var abgelehnt = gate.querySelector('[data-age-abgelehnt]');
    var form = gate.querySelector('[data-age-form]');
    var fehler = gate.querySelector('[data-age-fehler]');
    var zurueck = gate.querySelector('[data-age-zurueck]');
    var tag = gate.querySelector('[data-age-tag]');
    var monat = gate.querySelector('[data-age-monat]');
    var jahr = gate.querySelector('[data-age-jahr]');
    var felder = [tag, monat, jahr];

    function oeffnen() {
      gate.hidden = false;
      gate.classList.add('is--open');
      document.body.classList.add('age-gate-offen');
      if (tag) tag.focus();
    }

    function schliessen() {
      gate.classList.remove('is--open');
      gate.hidden = true;
      document.body.classList.remove('age-gate-offen');
    }

    function zeige(welcher) {
      if (frage) frage.hidden = welcher !== 'frage';
      if (abgelehnt) abgelehnt.hidden = welcher !== 'abgelehnt';
    }

    function meldung(text) {
      if (!fehler) return;
      if (text) {
        fehler.textContent = text;
        fehler.hidden = false;
        gate.classList.add('hat--fehler');
      } else {
        fehler.textContent = '';
        fehler.hidden = true;
        gate.classList.remove('hat--fehler');
      }
    }

    /* Gibt es den Tag wirklich? 31.02. faellt hier durch. */
    function datumEchte(t, m, j) {
      var d = new Date(j, m - 1, t);
      return d.getFullYear() === j && d.getMonth() === m - 1 && d.getDate() === t;
    }

    function alterHeute(t, m, j) {
      var heute = new Date();
      var a = heute.getFullYear() - j;
      var diff = (heute.getMonth() + 1) - m;
      if (diff < 0 || (diff === 0 && heute.getDate() < t)) a--;
      return a;
    }

    function pruefen() {
      var t = parseInt((tag.value || '').replace(/\D/g, ''), 10);
      var m = parseInt((monat.value || '').replace(/\D/g, ''), 10);
      var j = parseInt((jahr.value || '').replace(/\D/g, ''), 10);

      if (!tag.value || !monat.value || !jahr.value) {
        meldung('Bitte tragen Sie Ihr vollständiges Geburtsdatum ein.');
        (!tag.value ? tag : (!monat.value ? monat : jahr)).focus();
        return;
      }
      if (isNaN(t) || isNaN(m) || isNaN(j) || String(j).length !== 4) {
        meldung('Bitte nur Zahlen eintragen, das Jahr vierstellig (z. B. 1985).');
        return;
      }
      if (j < 1900 || j > new Date().getFullYear()) {
        meldung('Bitte prüfen Sie das Jahr.');
        jahr.focus();
        return;
      }
      if (!datumEchte(t, m, j)) {
        meldung('Dieses Datum gibt es nicht. Bitte prüfen Sie Ihre Eingabe.');
        return;
      }

      meldung('');
      if (alterHeute(t, m, j) >= mindestalter) {
        try { speicher.setItem(KEY, '1'); } catch (e) {}
        schliessen();
      } else {
        zeige('abgelehnt');
        if (zurueck) zurueck.focus();
      }
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      pruefen();
    });

    /* Nur Ziffern, und nach dem letzten Zeichen weiter ins naechste Feld. */
    for (var i = 0; i < felder.length; i++) {
      (function (feld, naechstes, vorheriges) {
        if (!feld) return;
        feld.addEventListener('input', function () {
          var sauber = feld.value.replace(/\D/g, '');
          if (sauber !== feld.value) feld.value = sauber;
          meldung('');
          if (naechstes && sauber.length >= parseInt(feld.getAttribute('maxlength'), 10)) {
            naechstes.focus();
          }
        });
        feld.addEventListener('keydown', function (e) {
          if (e.key === 'Backspace' && !feld.value && vorheriges) vorheriges.focus();
        });
      })(felder[i], felder[i + 1], felder[i - 1]);
    }

    if (zurueck) zurueck.addEventListener('click', function () {
      zeige('frage');
      meldung('');
      if (tag) { tag.value = ''; monat.value = ''; jahr.value = ''; tag.focus(); }
    });

    /* Tabulator soll den Kasten nicht verlassen koennen. */
    gate.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var moegliche = gate.querySelectorAll('input, button');
      var liste = [];
      for (var k = 0; k < moegliche.length; k++) {
        if (moegliche[k].offsetParent !== null) liste.push(moegliche[k]);
      }
      if (!liste.length) return;
      var erster = liste[0];
      var letzter = liste[liste.length - 1];
      if (e.shiftKey && document.activeElement === erster) { e.preventDefault(); letzter.focus(); }
      else if (!e.shiftKey && document.activeElement === letzter) { e.preventDefault(); erster.focus(); }
    });

    zeige('frage');
    oeffnen();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var i;
    var banners = document.querySelectorAll('.home--slider');
    for (i = 0; i < banners.length; i++) initBannerSlider(banners[i]);

    var psliders = document.querySelectorAll('.product-slider');
    for (i = 0; i < psliders.length; i++) initProductSlider(psliders[i]);

    var tabs = document.querySelectorAll('.tab-menu--product');
    for (i = 0; i < tabs.length; i++) initTabs(tabs[i]);

    initMobileNav();
    initFilter();
    initNoteButtons();
    initNotePage();
    initCartForm();
    initAgeGate();
  });
})();
